import React from 'react'
import { ColumnDef } from '@tanstack/react-table'
import { VoucherType } from '../../../types'
import { FaCaretDown, FaCaretRight } from 'react-icons/fa'
import VoucherStateBadge from '../VoucherStateBadge'
import { formatPaymentDate, formatPeriod } from '../../../utils/utils'

export const getReportsColumns = (): ColumnDef<VoucherType>[] => [
  {
    id: 'expander',
    header: () => null,
    cell: ({ row }) =>
      row.getCanExpand() ? (
        <button
          onClick={row.getToggleExpandedHandler()}
          style={{ cursor: 'pointer', border: 'none', background: 'none' }}
        >
          {row.getIsExpanded() ? (
            <FaCaretDown className="text-primary" />
          ) : (
            <FaCaretRight className="text-primary" />
          )}
        </button>
      ) : null,
    size: 40,
  },
  {
    accessorKey: 'reference_number',
    header: 'Reference #',
    cell: ({ row }) => row.original.reference_number,
    enableColumnFilter: false,
    size: 20,
  },
  { accessorFn: (row) => row.department.name, header: 'Department', size: 20 },
  {
    accessorFn: (row) =>
      row.created_by.first_name + ' ' + row.created_by.last_name,
    header: 'Prepared by',
    size: 200,
  },
  {
    accessorKey: 'state',
    header: 'State',
    cell: ({ row }) => <VoucherStateBadge state={row.original.state} />,
    size: 10,
  },
  {
    accessorFn: (row) => formatPaymentDate(row.paid_by_amin),
    header: 'Payment',
    enableColumnFilter: false,
    size: 80,
  },
  {
    accessorFn: (row) => formatPeriod(row.expense_period),
    header: 'Expense Month',
    enableColumnFilter: false,
    size: 80,
  },
  {
    header: 'Cost Centers',
    cell: ({ row }) => (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
        }}
      >
        {row.original.voucher_cost_category.map((cat) => (
          <div key={cat.id}>
            <div style={{ fontWeight: 'bold' }}>{cat.cost_category.parent.name}</div>
            <div style={{ paddingLeft: '10px' }}>
              {cat.cost_category.name} ({cat.cost_category.code}) :{' '}
              {cat.cost_share} {row.original.currency}
            </div>
          </div>
        ))}
      </div>
    ),
    size: 300,
  },
  {
    accessorFn: (row) => `${row.total_amount.toFixed(2)} ${row.currency}`,
    header: 'Amount',
    enableColumnFilter: false,
    meta: { align: 'right' },
    size: 120,
  },
]
